import { nameActions } from '../actions';

export default function personalDetails ( initialState = {}, action ) {
    const newState = { ...initialState };

    switch ( action.type ) {
        case nameActions.SET_NAME: return generalPersonalDetailsReducer( newState, action );
        default: return newState;
    }
}

function generalPersonalDetailsReducer ( newState, action ) {
    delete action.type;
    newState = Object.assign( {}, { ...action } );
    return newState;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/name.js